import Vue from "vue";
import Router from "vue-router";
import commonRouter from "./modules/common"; // 公共路由
import shoppingRouter from "./modules/shopping"; // 首页路由
import loginRouter from "./modules/login"; // 登录路由
import maReadyRouter from "./modules/maReady"; // 登录路由

Vue.use(Router);

export const constantRouterMap = [
  ...commonRouter,
  ...shoppingRouter,
  ...loginRouter,
  ...maReadyRouter
];

export default new Router({
  mode: "history", // require service support
  // 浏览器回退,切换路由时默认滚动的位置
  scrollBehavior: () => ({
    y: 0
  }),
  routes: constantRouterMap
});
